import { render, staticRenderFns } from "./SwapItemDetails.vue?vue&type=template&id=fba8ef58&"
import script from "./SwapItemDetails.vue?vue&type=script&lang=js&"
export * from "./SwapItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./SwapItemDetails.vue?vue&type=style&index=0&id=fba8ef58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports